/* 
https://developer.mozilla.org/en-US/docs/Web/API/WebHID_API
*/

// Svelte 5 no longer needs svelte/store imports for basic reactivity

// Create reactive state for pedal
export const pedalState = $state({
    enable: false,
    selectedInput: undefined,
    inputDevices: [],
    functionMapping: {
        0: 'pause',
        1: 'fastForward',
        2: 'play',
        3: 'none',
        4: 'rewind'
    }
});

// Variable to store rewind state interval
let rewindState;
let player;

// Load saved settings from localStorage
export function loadSavedSettings() {
    try {
        const savedSettings = localStorage.getItem("cc-device-defaults");
        if (savedSettings) {
            const settings = JSON.parse(savedSettings);
            
            // Update state with saved settings
            pedalState.enable = settings.enable || false;
            pedalState.functionMapping = settings.functionMapping || pedalState.functionMapping;
            
            // If enabled, initialize devices
            if (pedalState.enable) {
                initializeDevices(settings.deviceName);
            }
        }
    } catch (err) {
        console.error("Error loading saved pedal settings:", err);
    }
}

// Initialize devices and select saved device if available
async function initializeDevices(savedDeviceName) {
    try {
        let devices = await navigator.hid.getDevices();
        let deviceProductIds = [];
        
        devices.forEach((device) => {
            if (device.productName && deviceProductIds.indexOf(device.productId) === -1) {
                pedalState.inputDevices.push(device);
                deviceProductIds.push(device.productId);
                
                // Select the previously saved device if found
                if (savedDeviceName && device.productName === savedDeviceName) {
                    enableDevice(device);
                }
            }
        });
        
        // If no saved device was found but devices are available, select the first one
        if (!pedalState.selectedInput && pedalState.inputDevices.length > 0) {
            enableDevice(pedalState.inputDevices[0]);
        }
    } catch (err) {
        console.error("Error initializing HID devices:", err);
    }
}

// Function to select device by name
export function selectDeviceByName(name) {
    const index = pedalState.inputDevices.findIndex(d => {
        return d.productName === name;
    });

    selectDeviceByIndex(index);
}

// Function to select device by index
export function selectDeviceByIndex(index) {
    if (index < 0) {
        pedalState.enable = false;
        return;
    }

    enableDevice(pedalState.inputDevices[index]);
}

// Function to enable device
export function enableDevice(device) {
    if (!device) {
        pedalState.enable = false;
        return;
    }

    pedalState.selectedInput = device;
    try {
        device.open();
    } catch (err) {
        console.log(err.message);
    }

    device.addEventListener("inputreport", (event) => {
        //console.log(event);
        const { data } = event;
        const value = data.getUint8(0);

        //console.log(value);
        /* value mapping */
        /* 
            2 = play
            1 = fast forward
            4 = rewind
            0 = pause
        */

        if (!player) {
            return;
        }

        switch (pedalState.functionMapping[value]) {
            case 'play':
                setTimeout(function () {
                    player.play();
                }, 0);
                break;
            case 'fastForward':
                player.speed = 8;
                setTimeout(function () {
                    player.play();
                }, 0);
                break;
            case 'rewind':
                rewindState = setInterval(() => {
                    player.rewind(0.25);
                    setTimeout(function () {
                        player.play();
                    }, 0);
                }, 50);

                break;
            case 'pause':
                /* pause */
                player.pause();
                player.speed = 1;
                if (rewindState) {
                    clearInterval(rewindState);
                    rewindState = undefined;
                }
                break;
            default:
                console.log("Unknown Value: " + value);
        }
    });
}

// Function to toggle pedal control
export async function togglePedalControl(enable) {
    pedalState.enable = enable ?? !pedalState.enable;
    pedalState.inputDevices = [];
    pedalState.selectedInput = undefined;

    console.log("Toggling Pedal Control: " + pedalState.enable);

    if (pedalState.enable) {
        try {
            await navigator.hid.requestDevice({ filters: [] });
        } catch (err) {
            console.log(err.message);
        }

        let devices = await navigator.hid.getDevices();
        let deviceProductIds = [];
        devices.forEach((device) => {
            if (device.productName && deviceProductIds.indexOf(device.productId) === -1) {
                pedalState.inputDevices.push(device);
                deviceProductIds.push(device.productId);
            }
        });
    }
}

// Initialize settings from localStorage when module loads
loadSavedSettings();

// Export a function to set the player reference
export function setPlayer(playerRef) {
    player = playerRef;
}